import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemDialog from "../../../components/UIToolkit/Popups/Dialog";

type Props = {
	open: boolean;
	name: string;
	isDeleting: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

/** Confirms deleting a custom printout, which removes it for everyone in the department. */
export const CustomPrintoutDeleteDialog: FC<Props> = ({ open, name, isDeleting, onConfirm, onClose }) => {
	const { t } = useTranslation();
	return (
		<SystemDialog
			open={open}
			onClose={onClose}
			title={t("printout.custom.ai.delete.title", { name })}
			body={t("printout.custom.ai.delete.body")}
			confirm={t("printout.custom.ai.delete.confirm")}
			cancel={t("cancel")}
			confirmButtonVariant="delete"
			onConfirm={onConfirm}
			confirmLoading={isDeleting}
			confirmDisabled={isDeleting}
			dataTestId="custom-printout-delete-dialog"
			confirmDataTestId="custom-printout-delete-confirm"
			cancelDataTestId="custom-printout-delete-cancel"
		/>
	);
};
